import PrivacyPage from "../../src/components/legal/PrivacyPage";

export default PrivacyPage;
